import "./Skills.css";
import {
  FaCalculator,
  FaCogs,
  FaDraftingCompass,
  FaFileSignature,
  FaIndustry,
  FaLaptopCode,
  FaPalette,
  FaRocket,
} from "react-icons/fa";

const skills = [
  {
    title: "Проектировать мебель",
    description:
      "Проектировать мебель любой сложности под реальные задачи клиента и пространства.",
    icon: FaDraftingCompass,
    color: "#5096ff",
  },
  {
    title: "Работать в БАЗИС",
    description:
      "Уверенно использовать ключевые инструменты БАЗИС для быстрого и точного результата.",
    icon: FaLaptopCode,
    color: "#ff6f50",
  },
  {
    title: "Готовить документацию",
    description:
      "Готовить полный пакет документов, по которому производство запускается без вопросов.",
    icon: FaFileSignature,
    color: "#ffb359",
  },
  {
    title: "Продумывать конструкцию",
    description:
      "Продумывать конструкцию так, чтобы ее было реально и выгодно изготовить.",
    icon: FaCogs,
    color: "#af93ff",
  },
  {
    title: "Учитывать оборудование",
    description:
      "Сразу учитывать возможности станков и цеха, избегая ошибок на этапе запуска.",
    icon: FaIndustry,
    color: "#50c0ff",
  },
  {
    title: "Подбирать материалы",
    description:
      "Подбирать материалы и фурнитуру под бюджет, долговечность и визуальную задачу.",
    icon: FaPalette,
    color: "#4bd071",
  },
  {
    title: "Считать стоимость",
    description:
      "Точно считать себестоимость и формировать понятную, прибыльную цену изделия.",
    icon: FaCalculator,
    color: "#4b77b9",
  },
  {
    title: "Запускать без доработок",
    description:
      "Передавать в производство проекты, которые запускаются быстро и без переделок.",
    icon: FaRocket,
    color: "#5096ff",
  },
];

function Skills() {
  return (
    <section className="skills" id="skills">
      <h2 className="skills__title">Чему вы научитесь:</h2>
      <div className="skills-layout">
        <p className="skills-layout__subtitle">
          Практические навыки, которые вы сможете применять в работе сразу после
          прохождения курса.
        </p>
        <ul className="skills-grid">
          {skills.map((skill, index) => {
            const Icon = skill.icon;

            return (
              <li
                key={`skill-${index + 1}`}
                className="skills-card"
                style={{ "--skill-accent": skill.color }}
              >
                <span className="skills-card__icon-wrap" aria-hidden="true">
                  <Icon className="skills-card__icon" />
                </span>
                <h3 className="skills-card__title">{skill.title}</h3>
                <p className="skills-card__text">{skill.description}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export default Skills;
